"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultDataFactory = require("@rdfjs/data-model");

var jsonld_context_parser_1 = require("jsonld-context-parser");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * Utilities for conversion.
 */


var Util =
/*#__PURE__*/
function () {
  function Util(settings) {
    _classCallCheck(this, Util);

    this.nodeHandlers = {};
    this.nodeValueHandlers = {};
    this.directiveNodeHandlers = {};
    this.settings = settings;
    this.dataFactory = settings.dataFactory || DefaultDataFactory;
    this.operationFactory = new sparqlalgebrajs_1.Factory(this.dataFactory);
    this.contextParser = new jsonld_context_parser_1.ContextParser();
  }
  /**
   * Register a new {@link NodeHandlerAdapter}.
   * @param {NodeHandlerAdapter<any>} nodeHandler A handler for converting GraphQL nodes to operations.
   */


  _createClass(Util, [{
    key: "registerNodeHandler",
    value: function registerNodeHandler(nodeHandler) {
      this.nodeHandlers[nodeHandler.targetKind] = nodeHandler;
    }
    /**
     * Register a new {@link NodeValueHandlerAdapter}
     * @param {NodeValueHandlerAdapter<any>} nodeValueHandler A handler for converting GraphQL value nodes
     *                                                        to terms and patterns.
     */

  }, {
    key: "registerNodeValueHandler",
    value: function registerNodeValueHandler(nodeValueHandler) {
      this.nodeValueHandlers[nodeValueHandler.targetKind] = nodeValueHandler;
    }
    /**
     * Register a new {@link DirectiveNodeHandlerAdapter}
     * @param {DirectiveNodeHandlerAdapter} directiveNodeHandler A handler for handling GraphQL directives.
     */

  }, {
    key: "registerDirectiveNodeHandler",
    value: function registerDirectiveNodeHandler(directiveNodeHandler) {
      this.directiveNodeHandlers[directiveNodeHandler.targetKind] = directiveNodeHandler;
    }
    /**
     * Get the operation for the given GraphQL node.
     * @param {T} node A GraphQL node.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {Operation} A SPARQL algebra operation.
     */

  }, {
    key: "handleNode",
    value: function handleNode(node, convertContext) {
      var nodeHandler = this.nodeHandlers[node.kind];

      if (!nodeHandler) {
        throw new Error("Unsupported GraphQL node '".concat(node.kind, "'"));
      }

      return nodeHandler.handle(node, convertContext);
    }
    /**
     * Get the terms and patterns for the given value node.
     * @param {T} node A GraphQL node.
     * @param {string} fieldName The name of the field or argument in which the value was encapsulated.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {IValueNodeHandlerOutput} The RDF terms and patterns.
     */

  }, {
    key: "handleNodeValue",
    value: function handleNodeValue(node, fieldName, convertContext) {
      var nodeValueHandler = this.nodeValueHandlers[node.kind];

      if (!nodeValueHandler) {
        throw new Error("Unsupported GraphQL value node '".concat(node.kind, "'"));
      }

      return nodeValueHandler.handle(node, fieldName, convertContext);
    }
    /**
     * Get the handler output for the given directive.
     * @param {IDirectiveContext} directiveContext The current directive context.
     * @param {IConvertContext} convertContext A conversion context.
     * @return {IDirectiveNodeHandlerOutput} The directive node handler output or null.
     */

  }, {
    key: "handleDirectiveNode",
    value: function handleDirectiveNode(directiveContext, convertContext) {
      var directiveNodeHandler = this.directiveNodeHandlers[directiveContext.directive.name.value];

      if (!directiveNodeHandler) {
        return null;
      }

      return directiveNodeHandler.handle(directiveContext, convertContext);
    }
    /**
     * Join the given array of operations.
     * If all operations are BGPs, then a single big BGP with all patterns from the given BGPs will be created.
     * @param {Operation[]} operations An array of operations.
     * @return {Operation} A single joined operation.
     */

  }, {
    key: "joinOperations",
    value: function joinOperations(operations) {
      if (operations.length === 1) {
        return operations[0];
      } // Check if which operations are BGPs


      var bgps = [];
      var nonBgps = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var operation = _step.value;

          if (operation.type === 'bgp') {
            bgps.push(operation);
          } else {
            nonBgps.push(operation);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (bgps.length === operations.length) {
        // Create a big BGP from all BGPs
        return this.joinOperationsAsBgp(bgps);
      } else if (bgps.length === operations.length - 1 && nonBgps[0].type === 'leftjoin' && nonBgps[0].left.type === 'bgp') {
        // Check if we have one left-join (with a BGP on the left), and the rest are BGPs.
        // If so, merge the BGPS within the left-hand-side of the left-join.
        var originalLeftJoin = nonBgps[0];
        bgps.push(originalLeftJoin.left);
        return this.operationFactory.createLeftJoin(this.joinOperationsAsBgp(bgps), originalLeftJoin.right);
      } else if (nonBgps.length === operations.length) {
        // Create nested joins
        return this.joinOperationsAsNestedJoin(nonBgps);
      } else {
        // Join as much BGPs together as possible, and join with the other operations
        return this.joinOperationsAsNestedJoin([this.joinOperationsAsBgp(bgps), this.joinOperationsAsNestedJoin(nonBgps)]);
      }
    }
  }, {
    key: "joinOperationsAsBgp",
    value: function joinOperationsAsBgp(operations) {
      return this.operationFactory.createBgp([].concat.apply([], operations.map(function (op) {
        return op.patterns;
      })));
    }
  }, {
    key: "joinOperationsAsNestedJoin",
    value: function joinOperationsAsNestedJoin(operations) {
      var _this = this;

      return operations.reverse().reduce(function (prev, cur) {
        return prev ? _this.operationFactory.createJoin(cur, prev) : cur;
      }, null);
    }
    /**
     * Append a field's label to a path.
     * @param {string[]} path A path.
     * @param {string} fieldLabel A field label.
     * @return {string[]} A new path array.
     */

  }, {
    key: "appendFieldToPath",
    value: function appendFieldToPath(path, fieldLabel) {
      return path.concat([fieldLabel]);
    }
    /**
     * Get the label of a field by taking into account the alias.
     * @param {FieldNode} field A field node.
     * @return {string} The field name or alias.
     */

  }, {
    key: "getFieldLabel",
    value: function getFieldLabel(field) {
      return (field.alias ? field.alias : field.name).value;
    }
    /**
     * Convert a field node to a variable built from the node name and the current path inside the context.
     * @param {string} fieldLabel A field label.
     * @param {IConvertContext} convertContext A convert context.
     * @param {string} variableDelimiter A variable delimiter.
     * @return {Variable} A variable.
     */

  }, {
    key: "nameToVariable",
    value: function nameToVariable(fieldLabel, convertContext) {
      return this.dataFactory.variable((convertContext.path.length ? convertContext.path.join(this.settings.variableDelimiter) + this.settings.variableDelimiter : '') + fieldLabel);
    }
    /**
     * Convert a GraphQL term into a URI using the given context.
     * @param {string} value A GraphQL term.
     * @param {IContext} context A JSON-LD context.
     * @return {NamedNode} A named node.
     */

  }, {
    key: "valueToNamedNode",
    value: function valueToNamedNode(value, context) {
      var contextValue = context[value];

      if (this.settings.requireContext && !contextValue) {
        throw new Error('No context entry was found for ' + value);
      }

      if (contextValue && !(typeof contextValue === 'string')) {
        contextValue = contextValue['@id'];
      }

      return this.dataFactory.namedNode(contextValue || value);
    }
    /**
     * Get an argument by name.
     * This will return null if the argument could not be found.
     * @param {ReadonlyArray<ArgumentNode>} args Arguments or null.
     * @param {string} name The name of an argument.
     * @return {ArgumentNode} The named argument.
     */

  }, {
    key: "getArgument",
    value: function getArgument(args, name) {
      if (args) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var argument = _step2.value;

            if (argument.name.value === name) {
              return argument;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return null;
    }
    /**
     * Create a pattern with an rdf:type predicate.
     * @param {Term} subject The subject.
     * @param {NamedTypeNode} typeCondition The object name.
     * @param {IConvertContext} convertContext A convert context.
     * @return {Pattern} A pattern.
     */

  }, {
    key: "newTypePattern",
    value: function newTypePattern(subject, typeCondition, convertContext) {
      return this.operationFactory.createPattern(subject, this.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#type'), this.valueToNamedNode(typeCondition.name.value, convertContext.context), convertContext.graph);
    }
    /**
     * Create a quad pattern when the predicate is a name node that needs to be translated using the context.
     * @param {Term} subject The subject.
     * @param {NameNode} predicateName The name node for the predicate.
     * @param {Term} object The object.
     * @param {Term} graph The graph.
     * @param {IContext} context A context.
     * @return {Pattern} A quad pattern.
     */

  }, {
    key: "createQuadPattern",
    value: function createQuadPattern(subject, predicateName, object, graph, context) {
      var predicate = this.valueToNamedNode(predicateName.value, context);

      if (context && context[predicateName.value] && context[predicateName.value]['@reverse']) {
        return this.operationFactory.createPattern(object, predicate, subject, graph);
      }

      return this.operationFactory.createPattern(subject, predicate, object, graph);
    }
    /**
     * Create a quad path when the predicate is a list node with field alternatives
     * that need to be translated using the context.
     * @param {Term} subject The subject.
     * @param {NameNode} predicateName The name node for the predicate.
     * @param {Term} object The object.
     * @param {Term} graph The graph.
     * @param {IContext} context A context.
     * @return {Path} A quad property path.
     */

  }, {
    key: "createQuadPath",
    value: function createQuadPath(subject, predicateName, predicateAlternatives, object, graph, context) {
      var predicateInitial = this.valueToNamedNode(predicateName.value, context);
      var pathSymbol = this.operationFactory.createLink(predicateInitial); // Add all fields in the list as predicate alternatives

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = predicateAlternatives.values[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var predicateAlternative = _step3.value;

          if (predicateAlternative.kind !== 'EnumValue') {
            throw new Error('Invalid value type for \'alt\' argument, must be EnumValue, but got ' + predicateAlternative.kind);
          }

          pathSymbol = this.operationFactory.createAlt(pathSymbol, this.operationFactory.createLink(this.valueToNamedNode(predicateAlternative.value, context)));
        } // Reverse the path based on the initial predicate

      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (context && context[predicateName.value] && context[predicateName.value]['@reverse']) {
        return this.operationFactory.createPath(object, pathSymbol, subject, graph);
      }

      return this.operationFactory.createPath(subject, pathSymbol, object, graph);
    }
  }]);

  return Util;
}();

exports.Util = Util;